export * from './device-lock.component';
